import React from 'react';

type CustomCheckBoxProps = {
    customClassName?: string;
    disabled?: boolean;
};

export default function CustomCheckBox({ customClassName, disabled = false }: CustomCheckBoxProps) {
    const stateClassName = disabled
        ? 'bg-[#8A8A8A] peer-checked:bg-[#8A8A8A] border-[#8A8A8A] text-white/70 opacity-70 cursor-not-allowed'
        : 'bg-[#ffffff] peer-checked:bg-[#DD06AE] border-[#C4C4C4]';

    return (
        <div
            className={`${customClassName ? customClassName : ''} flex items-center justify-center font-black w-[18px] h-[18px] border border-1 rounded-[4px] mr-2 ${stateClassName}`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-1 -1 14 14"
                fill="none"
                className="w-6 h-6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <title>CustomCheckBox</title>
                <path d="M10 3L4.5 8.5L2 6" />
            </svg>
        </div>
    );
}
